<template>
	<b-container fluid class="px-1">    
	    <b-row class="justify-content-center mx-0">
	      <h1 style="text-align: center;">Terms Of Service</h1>
	    </b-row>
	    <b-row class="justify-content-center mx-0">
	      <p style="padding-left: 10%; padding-right: 10%;">
	      	1. Terms<br>

			By accessing this website, you are agreeing to be bound by these website Terms and Conditions of Use, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trade mark law.<br><br>

			2. Use License<br>

			Permission is granted to download copy of the materials (information or software) on this website. This is the grant of a license, not a transfer of title, and under this license you may not:<br><br>

			- modify or copy the materials;<br>
			- attempt to decompile or reverse engineer any software contained on Silverdor.com;<br>
			- initiate a dispute or chargeback on your order;<br>
			- remove any copyright or other proprietary notations from the materials; or<br>
			- transfer or attempt to transfer the materials to another person or “mirror” the materials on any other server.<br><br>

			This license shall automatically terminate if you violate any of these restrictions or any other special restrictions determined by us at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.<br><br>

			3. Refund Policy<br>

			There is no refund for all orders, all sales are final. We provide 24/7 support, if you have questions, suggestions or need assistance please contact us through this page:support and a support staff will get in touch with you.<br><br>

			4. Disclaimer<br>

			The materials on Silverdor.com are provided “as is”. Silverdor.com makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties, including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights. Further, Silverdor.com does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.<br><br>

			5. Limitations<br>

			In no event shall Silverdor.com or its suppliers be liable for any damages arising out of the use or inability to use the materials on Silverdor.com, even if Silverdor.com or a Silverdor.com authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.<br><br>

			6. Revisions and Errata<br>

			The materials appearing on Silverdor.com could include technical, typographical, or photographic errors. Silverdor.com may make changes to the materials contained on its website at any time without notice. Silverdor.com does not, however, make any commitment to update the materials.<br><br>

			7. Purchases and Payment Processing<br>

			Silverdor.com allow individuals to complete transactions possibly in a single checkout process. Our order process is conducted by Paypal.<br><br>

			8. Links<br>

			Silverdor.com has not reviewed all of the sites linked to its Internet website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Silverdor.com. Use of any such linked website is at the user’s own risk.<br><br>

			9. Refusal of Service and Business Relations.<br>

			Silverdor.com reserves the right to terminate license and cease support in instances of defamation, libel, abuse, or harassment. Silverdor.com will terminate all support and relations in instances of software piracy, including but not limited to “nulled”, “cracked”, or otherwise unlicensed versions of Silverdor.com scripts, extensions/modules or plugins.<br><br>

			10. Intellectual Property<br>

			Silverdor.com contains material which is owned by or licensed to us. This material includes, but is not limited to trademark, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.<br><br>

			11. Site Terms of Use Modifications<br>

			Silverdor.com may revise these terms of use for its website at any time without notice.<br> By using this website you are agreeing to be bound by the then current version of these Terms and Conditions of Use.<br>
			</p>
	    </b-row>
	</b-container> 
</template>

<script>
export default {
 
  data() {
    return {
      visible: false
    };
  },

  methods:{
 
  },

  components: { 
  },

  computed: {
  }
};
</script>
<style scoped>


</style>